import React from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';

const RefundTransactionModal = () => {
    return (
        <div className={styles.wrapper}>
            <Typography variant="h4" className={styles.title}>
                Refund
            </Typography>
            <Typography variant="body2" className={styles.description}>
                Are you sure you want to refund this transaction?
            </Typography>
        </div>
    );
};

export default RefundTransactionModal;
